export const REFRESH_COUNTDOWN_INTERVAL = 1000;

export const MEDIUM_WARNING_VALUE = '10:00';
export const HIGH_WARNING_VALUE = '05:00';
